'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"stepper":"stepper-module_stepper__gIX06","step":"stepper-module_step__PCkTe","step_inactive":"stepper-module_step_inactive__AO-Cx","step_active":"stepper-module_step_active__o5pUo","active":"stepper-module_active__2VuKO","dot":"stepper-module_dot__eeKqA","stepperDisabled":"stepper-module_stepperDisabled__kWXrn"};

exports.default = styles;
//# sourceMappingURL=stepper.module.scss.js.map
